"use client";
import { CloseOutlined } from "@ant-design/icons";
import { Drawer } from "antd";
import { useRouter } from "next/navigation";
import React from "react";

import Logo from "../logo/logo";

import InstallerRegisterButton from "./installerRegisterButton";
import LoginButton from "./loginButton";
import MenuStructure from "./menuStructure";



interface MenuModalProps {
  onClose: () => void;
  open: boolean;
}

const MenuDrawer = ({ onClose, open }: MenuModalProps) => {
  const router = useRouter();
  const handlerLogo = () => {
    onClose();
    router.push("/");
  };
  return (
    <Drawer
      title={
        <div className="flex w-full justify-between items-center">
          <button
            type="button"
            className="flex text-base items-center justify-center w-8 h-8"
            onClick={onClose}
          >
            <CloseOutlined
              alt="hamburgerMenu"
              className="text-2xl transition-colors duration-500"
            />
          </button>
          <Logo
            onClick={handlerLogo}
            className="max-[359px]:!w-[84px] sm:!w-[84px]"
          />
          <div className="flex items-stretch gap-1.5 shrink-0">
            <InstallerRegisterButton />
            <LoginButton />
          </div>
        </div>
      }
      placement="right"
      closable={false}
      onClose={onClose}
      open={open}
      key="right"
      width="100%"
      classNames={{
        header: "px-6 py-3 border-b-0",
        wrapper: "sm:!max-w-xs",
        body:"!px-5"
      }}
    >
      <MenuStructure onClose={onClose} />
    </Drawer>
  );
};

export default MenuDrawer;
